import { atom } from "recoil";

const AirlineSelectedCountryCodeAtom = atom<string>({
    key: 'airlineSelectedCountryCodeAtomKey',
    default: ''
})

export default AirlineSelectedCountryCodeAtom;